import {PATH, SOURCE_TYPE} from '../constants/Tpiq.constants';
import {InterPolateUrlService} from './InterPolateUrl.service';
import {Session} from './Session';
import {UrlService} from './UrlService';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';

export class TaxplanIQServices extends InterPolateUrlService{

  private headers: HttpHeaders;
  http: HttpClient;

  defaultOptionsArgs: any;

  constructor(http: HttpClient) {
    super();
    this.http = http;
    this.headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
  }

  protected getUrl(servicePath: string, sourceType: string) {
    let url = '';
    switch (sourceType) {
      case SOURCE_TYPE.NODE: {
        url = UrlService.getBaseUrl('NODE') + servicePath;
      }
                             break;
      case SOURCE_TYPE.JAVA: {
        url = UrlService.getBaseUrl('JAVA') + servicePath;
      }
                             break;
      case SOURCE_TYPE.BIG_PAY: {
        url = UrlService.getBaseUrl('BIGPAY') + servicePath;
      }
                                break;
      case SOURCE_TYPE.DOCUMENT: {
        url = UrlService.getBaseUrl('DOCUMENT') + servicePath;
      }
                                 break;
      case SOURCE_TYPE.DOWNLOAD: {
        url = UrlService.getBaseUrl('DOWNLOAD') + servicePath;
      }
                                 break;
                                  case SOURCE_TYPE.KNOLLI: {
        url = UrlService.getBaseUrl('KNOLLI') + servicePath;
      }
                                 break;
                                 
      default:
        url = servicePath;
        break;
    }
    return url;
  }

  create(servicePath: string, model: any, sourceType: any, options?: any, origin?: any): Observable<any>{
    if(sourceType !== 'knolli'){
      this.setHeaders(origin);
      const url = this.getUrl(servicePath, sourceType);
      const tempOptions = options ? options : this.defaultOptionsArgs;
      return this.http.post<any>(url, JSON.stringify(model), tempOptions);
    }else{
      const tempOptions = options || {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        })
      };
      const url = this.getUrl(servicePath, sourceType);
      return this.http.post<any>(url, JSON.stringify(model), tempOptions);
    }
  }

  update(servicePath: string, model: any, sourceType: string, options?: any, origin?: string): Observable<any>{
    this.setHeaders(origin);
    const url = this.getUrl(servicePath, sourceType);
    const tempOptions = options ? options : this.defaultOptionsArgs;
    return this.http.put<any>(url, JSON.stringify(model), tempOptions);
  }

  updateWithoutJson(servicePath: string, sourceType: string, options?: any): Observable<any>{
    this.setHeaders();
    const url = this.getUrl(servicePath, sourceType);
    const tempOptions: any = {
      headers: this.headers
    };
    return this.http.put<any>(url, null, tempOptions);
  }

  delete(servicePath: string, sourceType: string, options?: any): Observable<any>{
    this.setHeaders();
    const url = this.getUrl(servicePath, sourceType);
    const tempOptions = options ? options : this.defaultOptionsArgs;
    return this.http.delete<any>(url, tempOptions);
  }

  query(servicePath: string, sourceType: string, options?: any, origin?: string): Observable<any>{
    if(sourceType !== 'knolli'){
      this.setHeaders(origin);
    }
    const url = this.getUrl(servicePath, sourceType);
    const tempOptions = options ? options : this.defaultOptionsArgs;
    return this.http.get<any>(url, tempOptions);
  }

  createEmail(servicePath: string, model: any, sourceType: string, options?: any): Observable<any>{
    this.setHeaders();
    const url = this.getUrl(servicePath, sourceType);
    const tempOptions = options ? options : this.defaultOptionsArgs;
    return this.http.post<any>(url, (model), tempOptions);
  }

  createExcel(servicePath: string, model: any, sourceType: string, options?: any): Observable<any>{
    this.setHeaders();
    const url = this.getUrl(servicePath, sourceType);
    const tempOptions = options ? options : this.defaultOptionsArgs;
    return this.http.post<any>(url, (model), tempOptions);
  }

  createWithHeader(url: string, model: any, token: string): Observable<any>{
    this.headers = this.headers.delete('Authorization');
    if (token) {
      this.headers = this.headers.append('Authorization', 'Basic ' + btoa(token));
    }
    const defaultOptionsArgs: any = {
      headers : this.headers
    };
    return this.http.post(url, (model), defaultOptionsArgs);
  }

  exportCreate(servicePath: string, model: any, sourceType: string, options?: any): Observable<any>{
    this.setHeaders();
    const url = servicePath;
    const tempOptions = options ? options : this.defaultOptionsArgs;
    return this.http.post<any>(url, model, tempOptions);
  }

  setHeaders(origin?: any){
    this.headers = this.headers.delete('Authorization');
    if (Session.getToken() && Session.getToken() !== 'undefined') {
     this.headers = this.headers.set('Authorization', 'Bearer ' + Session.getToken());
    }
    this.defaultOptionsArgs = {
      headers : this.headers
    };
  }

  patch(servicePath: string, model: any, sourceType: string, options?: any): Observable<any>{
    this.setHeaders();
    const url = this.getUrl(servicePath, sourceType);
    const tempOptions = options ? options : this.defaultOptionsArgs;
    return this.http.patch<any>(url, JSON.stringify(model), tempOptions);
  }

  createArrayBuffer(servicePath: string, model: any, sourceType: string, options?: any, origin?: string): Observable<any>{
    this.setHeaders(origin);
    const url = this.getUrl(servicePath, sourceType);
    const tempOptions: any = {
      headers: this.headers,
      observe: 'response',
      responseType: 'arraybuffer'
    };
    return this.http.post<any>(url, JSON.stringify(model), tempOptions);
  }

}